export default "__VITE_ASSET__dCwsSKc6__"